import { useGetUserOrdersQuery } from "src/store/slices/client/client.api";
import OrderCard from "../../OrderCard/OrderCard";
import Tag from "src/components/Tag/Tag";
import Shell from "src/components/Shell/Shell";

import { useTranslation } from "react-i18next";
import { useOrdersList } from "../../../context/OrderListContext";
import { STATUS_MAP, UNKNOWN_STATUS, type OrderStatusKey } from "../../../constants";
import { DISCOUNTS_CARD_DATA_MAP, DISCOUNTS_CARD_ICON } from "./constants";
import { PaginationComponent } from "src/components";
import usePaginatedList from "../../../hooks/usePaginatedList";


export default function DiscountTransactions() {
  const { i18n } = useTranslation();
  const { dateRange } = useOrdersList();
  const { data, isFetching, error } = useGetUserOrdersQuery({
    Page: 1,
    pageSize: 1000000,
    moduleType: "Discounts",
    from: dateRange[0].locale("en").format("YYYY-MM-DDTHH:mm:ss[Z]"),
    to: dateRange[1].locale("en").format("YYYY-MM-DDTHH:mm:ss[Z]"),
    lang: i18n.language,
  });
  const { pageItems, paginationProps } = usePaginatedList(data?.orders, `${dateRange[0].valueOf()}-${dateRange[1].valueOf()}`);

  return (
    <Shell loading={isFetching} error={error} data={data?.orders}>
      <div className="flex w-full flex-col gap-4">
        {pageItems?.map((order: any) => {
          const item = order.orderItems?.[0];
          const status = STATUS_MAP?.[order?.statusEnum as keyof typeof STATUS_MAP] ?? UNKNOWN_STATUS;
          const cardData = {
            icon: DISCOUNTS_CARD_ICON,
            title: <div className="text-xl font-medium">{item?.brand ?? "-"}</div>,
            tag: <Tag label={status?.label} color={status?.color} className="rounded-full p-1 px-4 text-sm outline outline-current" />,
            data: {
              referenceNumber: order.referenceNumber,
              orderedAt: order.orderedAt,
              points: item?.points,
              provider: item?.provider,
              cardCode: item?.cardCode,
              cardPin: item?.cardPin,
              cardExpiryDate: item?.cardExpiryDate,
            },
            id: order.referenceNumber,
          };
          return <OrderCard key={order.referenceNumber} cardData={cardData} dataMap={DISCOUNTS_CARD_DATA_MAP} />;
        })}
        <PaginationComponent {...paginationProps} />
      </div>
    </Shell>
  );
}
